module.exports = __webpack_public_path__ + "img/Group 4167.14dfb1fa.svg";